
import { useLanguage } from '@/hooks/useLanguage';

export function Footer() {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-secondary/80 dark:bg-secondary/50 border-t border-border/50">
      <div className="container py-6 px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-2 md:mb-0 text-center md:text-left">
            <div className="flex items-center justify-center md:justify-start">
              <span className="font-bold text-lg tracking-tight text-primary">Cybermonit</span>
            </div>
            <p className="mt-2 text-sm text-muted-foreground">
              &copy; {currentYear} Cybermonit. {t('footer.rights')}.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
